// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__a7TfO","layoutContent":"Layout_layoutContent__P6Rs3"};